export default __webpack_public_path__ + "static/media/almax-champion.1af0df54.svg";